import { v4 as uuidv4 } from 'uuid';

export const UUIDUtils = {
  generateUUID: () => {
    const uuid = `${Number(new Date())}__${uuidv4()}`;
    return uuid;
  },
};
